import Icon from 'veui/components/Icon'
import { IconChevronRightCircle } from 'dls-icons-vue'

Icon.register('chevron-right-circle', IconChevronRightCircle)
